import { t } from 'i18next';

import { Box } from '@mui/system';
import {
  Card,
  CardHeader,
  CardContent
} from '@mui/material';

import PostCommentForm from 'src/layouts/common/threads/post-comment-form';
import PostCommentList from 'src/layouts/common/threads/post-comment-list';
import { useGetCompanyByIdQuery } from "src/services/connections/connections.service";

import Iconify from 'src/components/iconify';

type Props = {
  companyProfileId: string;
};


export const CompanyDetailSection = ({ companyProfileId }: Props) => {
  const { data: companyProfile } = useGetCompanyByIdQuery({ profile_id: companyProfileId }, {
    skip: !companyProfileId,
  });

  if (!companyProfile?.thread?.id) {
    return null;
  }

  return (
    <Card>
      <CardHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Iconify icon="uil:notes" />
            <Box>{t('companies.profile.thread.title')}</Box>
          </Box>
        }
      />
      <CardContent>
        <PostCommentForm thread_id={companyProfile.thread.id} />
        <PostCommentList thread_id={companyProfile.thread.id} />
      </CardContent>
    </Card>
  )
};